<template>
  <div class="field">
    <label
      v-if="label"
      class="label"
      :for="inputId"
    >{{ label }}</label>
    <div class="control">
      <input
        v-bind="$attrs"
        :checked="modelValue"
        :id="inputId"
        @input="$emit('update:modelValue', $event.target.checked)"
        class="checkbox"
        type="checkbox"
      />
    </div>
    <p
      class="help is-danger"
      v-if="hasError"
    >{{ error[0] }}</p>
  </div>
</template>

<script lang="ts">
import { defineComponent } from "vue"

/** The classic checkbox input */
export default defineComponent({
  inheritAttrs: false,
  props: {
    /** The input value */
    modelValue: Boolean,
    /** Label of the checkbox */
    label: String,
    /** Array of error messages */
    error: Object,
    /** Does not do anything */
    isLoading: Boolean,
    /** ID assigned to the input if present, otherwise uses the label */
    htmlId: String
  },
  computed: {
    hasError() {
      return this.error !== undefined
    },
    inputId() {
      if (this.htmlId === undefined) {
        if (this.label === undefined) {
          return null
        }
        return this.label.replaceAll(" ", "-").toLowerCase()
      } else {
        return this.htmlId
      }
    }
  }
})
</script>